//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AllowRunningOverFaceBoundaries",1,0],[0,"ImageFile",1,0],[0,"ImprintImageValue",1,0],[0,"MakeMonochrome",1,0],[1,"MaximumOffset",0,"Expression",0],[0,"MeshResolution",1,0],[0,"OverallTranslucency",1,0],[0,"PatternCountDirection1",1,0],[0,"PatternCountDirection2",1,0],[0,"PatternImage",1,0],[0,"ScaleToModel",1,0],[0,"ScaleUniform",1,0],[0,"SmoothEdge",1,0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0],[0,"UseCase",1,0]],[],[]];
SPLM.Features.TextureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TextureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TextureBuilder.ImprintImageValues = Object.freeze({
    "Dark" : "Dark", "Light" : "Light"});

SPLM.Features.TextureBuilder.MeshResolutions = Object.freeze({
    "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine"});

SPLM.Features.TextureBuilder.UseCases = Object.freeze({
    "Natural" : "Natural", "Graphical" : "Graphical"});

export default SPLM;